export default "__VITE_ASSET__DBNi1zpR__"